import React from "react";
import { SocialIcon } from "react-social-icons";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-40 md:flex-row flex-col items-center">
        
        {/* Profile Image */}
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-8 md:mb-0">
          <img
            className="w-64 h-64 rounded-full bg-white shadow-lg mx-auto"
            alt="Rohan Dhakal"
            src={require("../../assets/myimage.jpg")}
            loading="lazy"
          />
        </div>

        {/* Text Content */}
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left items-center text-center">
          
          {/* Tagline */}
          <p className="sm:text-xl text-lg font-medium text-white-gray mb-2">
            Software Engineer • CBDC • MERN Stack • UI/UX • Data & Cybersecurity
          </p>
          
          {/* Name */}
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Rohan Dhakal
          </h1>
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
              {/* Profile Description */}
              <p className="flex-1 leading-relaxed text-white-gray">
                Computer Engineering graduate from Kathmandu University with a balanced expertise 
                in software development, data systems, and cybersecurity. Experienced in building 
                scalable applications and APIs, performing data-driven analysis, and implementing 
                secure system design principles including API security, access control, and cryptography. 
                Contributed to public-sector digital infrastructure such as a Central Bank Digital Currency (CBDC) prototype. 
                Motivated to deliver impactful solutions that combine reliable software, meaningful data, and strong security.
              </p>
            
              {/* Social Links */}
              <div className="flex flex-row md:flex-col gap-3">
                <SocialIcon network="behance" url="https://www.behance.net/rohandhakal2" />
                <SocialIcon network="github" url="https://github.com/fearalert" />
                <SocialIcon network="linkedin" url="https://www.linkedin.com/in/dhakalrohan/" />
                <SocialIcon network="facebook" url="https://www.facebook.com/dhakal.rohan/" />
              </div>
            </div>
            
            {/* Buttons below the row */}
            <div className="flex justify-center md:justify-start mt-6 gap-4">
              <Link
                to="/resume"
                className="inline-flex text-white bg-dodger-blue border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded-full text-lg"
              >
                Portfolio
              </Link>
              <Link
                to="/contact"
                className="inline-flex text-gray-400 bg-button-gray border-2 border-dodger-blue py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded-full text-lg"
              >
                Contact
              </Link>
            </div>
        </div>
      </div>
    </section>
  );
}
